import React from 'react';

export default ({ size, color }) => {
  return (
    <div
      className={`dot-elastic 
      ${size ? 'dot-elastic--' + size : ''} 
      ${color ? 'dot-elastic--' + color : ''}`}
    >
      <div className="dot-elastic__first"></div>
      <div className="dot-elastic__second"></div>
      <div className="dot-elastic__last"></div>
    </div>
  );
};
